module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Condensed.585e32b.eot";